// extracted by mini-css-extract-plugin
module.exports = {"body":"_9bd5ac4"};